import React from 'react';
import TextField from '@mui/material/TextField';

export default function InputField(props) {
  return (
   <>
      <TextField
        type={props.type}
        id="outlined-basic"
        label={props.placeholder}
        variant="outlined"
        margin="normal"
        fullWidth
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        disabled={props.disabled}
        value={props.value}
        error={props.error}
        required={props.required}
        autoComplete={props.autoComplete}
        multiline={props.multiline}
        rows={props.rows}
        autoFocus={props.autoFocus}
      />
      {props.error && (
        <b>
          <div style={{ color: 'red' }}>{props.error}</div>
        </b>
      )}
   </>
  );
}
